import { ActionTypes } from 'modules/jobManager/ducks/actionTypes';
import { JobAction, JobTableFilterState } from 'modules/jobManager/types';

export const initialJobTableFilterState: JobTableFilterState = {
  jobStates: [],
  jobTypeNames: [],
};

export const jobTableFilterReducer = (state = initialJobTableFilterState, action?: JobAction) => {
  switch (action?.type) {
    case ActionTypes.SET_TABLE_FILTER: {
      const filters = (action?.payload as Partial<JobTableFilterState>) || {};
      return {
        ...state,
        ...filters,
      };
    }

    case ActionTypes.CLEAR_TABLE_FILTER:
      return initialJobTableFilterState;

    default:
      return state;
  }
};
